import owd from 'owd/owd';

export default class Contact extends owd.Component {
	init() {
        this.bind();
	}

	bind() {
        this.on('click', '.toggle-open', (e) => {
            e.preventDefault();
            $('.representatives').toggleClass('open');
        });

        this.on('click', this.dom.$body, (e) => {
            if (!$(e.target).is('.representatives') && !$(e.target).parents('.representatives').length) {
                $('.representatives').removeClass('open');
            }
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('contact', {
	component: Contact
});
